import { AppRoute, MenuActionId } from '@common/enums'

const WORKSPACE_ACTION_ROUTES: Partial<Record<MenuActionId, AppRoute>> = {
  [MenuActionId.INVITE_PEOPLE]: AppRoute.SETTINGS_WORKSPACE_MEMBERS,
  [MenuActionId.WORKSPACE_SETTINGS]: AppRoute.SETTINGS_WORKSPACE,
  [MenuActionId.CREATE_WORKSPACE]: AppRoute.WORKSPACE_CREATE,
}

export function getRouteForWorkspaceAction(actionId: string): AppRoute | null {
  return WORKSPACE_ACTION_ROUTES[actionId as MenuActionId] ?? null
}
